import type { ActionKind } from "@puszczyk/contracts";
import { useTranslation } from "react-i18next";
import { Badge } from "../../ui/Badge";

export function KindBadge({ kind }: { kind: ActionKind }) {
  const { t } = useTranslation();
  return kind === "exercise" ? <Badge tone="yellow">{t("action.exercise")}</Badge> : null;
}
